<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1280px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-tabs
          v-model="activeTab"
          type="card"
          @tab-click="changeTabFun()"
        >
          <el-tab-pane
            label="用户信息"
            name="consumerInfo"
          >
            <el-form
              ref="dialogAddEditViewForm"
              :model="dialogAddEditViewForm"
              :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
              class="add-edit-view-form"
              @submit.native.prevent
            >
              <div class="modal-box">
                <h3 class="modal-title">
                  基础信息
                </h3>
                <div class="modal-row-box">
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item
                        label="省区"
                        prop="provinceId"
                      >
                        <el-select
                          v-if="eventType!=='view'"
                          v-model="dialogAddEditViewForm.provinceId"
                          filterable
                          clearable
                          placeholder="请选择省区"
                          style="width:100%"
                          @change="changeProvinceFun"
                        >
                          <el-option
                            v-for="item in provinceOptions"
                            :key="item.label"
                            :label="item.label"
                            :value="item.data"
                          />
                        </el-select>
                        <el-input
                          v-else
                          v-model="dialogAddEditViewForm.provinceName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="姓名"
                        prop="name"
                      >
                        <el-input
                          v-model="dialogAddEditViewForm.name"
                          :disabled="eventType==='view'"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="电话"
                        prop="phone"
                      >
                        <el-input
                          v-model="dialogAddEditViewForm.phone"
                          :disabled="eventType!=='add'"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="性别">
                        <el-radio-group
                          v-model="dialogAddEditViewForm.sex"
                          :disabled="eventType==='view'"
                        >
                          <el-radio :label="1">
                            男
                          </el-radio>
                          <el-radio :label="2">
                            女
                          </el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="详细地址"
                        prop="address"
                      >
                        <el-input
                          v-model="dialogAddEditViewForm.address"
                          :disabled="eventType==='view'"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col
                      v-if="eventType==='view'"
                      :span="6"
                    >
                      <el-form-item label="状态">
                        <el-input
                          v-model="dialogAddEditViewForm.statusStr"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col
                      v-if="eventType==='view'"
                      :span="6"
                    >
                      <el-form-item label="可用积分">
                        <el-input
                          v-model="dialogAddEditViewForm.integral"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col
                      v-if="eventType==='view'"
                      :span="6"
                    >
                      <el-form-item label="累计积分">
                        <el-input
                          v-model="dialogAddEditViewForm.integralTotal"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane
            v-if="eventType==='view'"
            label="积分信息"
            name="integralInfo"
          >
            <view-table
              :table-columns="integralTableColumns"
              :table-data="integralListData"
              table-custom-height="540"
            />
          </el-tab-pane>
          <el-tab-pane
            v-if="eventType==='view'"
            label="扫码验真信息"
            name="caseInfo"
          >
            <view-table
              :table-columns="caseTableColumns"
              :table-data="caseListData"
              table-custom-height="540"
            />
          </el-tab-pane>
          <el-tab-pane
            v-if="eventType==='view'"
            label="兑奖信息"
            name="exchangeInfo"
          >
            <view-table
              :table-columns="exchangeTableColumns"
              :table-data="exchangeListData"
              table-custom-height="540"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import viewTable from '@/components/viewTable'
import { loadAreaDataApi } from '@/api/area'
import { initAppConsumerApi, saveOrUpdateAppConsumerApi, listAppConsumerIntegralListDataApi } from '@/api/appConsumer'
import { listSelectDataByConsumerIdApi } from '@/api/appConsumerScanCigaretteCaseInfo'
import { listAppConsumerIntegralExchangeRewardListDataApi } from '@/api/appConsumerIntegralExchangeReward'
export default {
  components: { viewTable },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        // return callback(new Error('手机号不能为空'));
        return callback();
      } else {
        const reg = /^1[3|4|5|6|7|8|9]\d{9}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号码'));
        }
      }
    }
    return {
      loading: true,
      activeTab: '',
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }, { validator: checkPhone, trigger: 'blur' }],
        address: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      integralTableColumns: [
        { label: '来源类型', prop: 'sourceTypeStr', width: 120 },
        { label: '来源名称', prop: 'sourceName', width: 360 },
        { label: '日期', prop: 'integralDateStr', width: 150 },
        { label: '获取积分', prop: 'integral', width: 100 },
        { label: '总积分', prop: 'surplusIntegral', width: 100 },
        { label: '备注', prop: 'remark' }
      ],
      integralListData: [],
      caseTableColumns: [
        { prop: 'isFirstStr', label: '是否首购', width: 80 },
        { prop: 'scanResult', label: '扫码内容', width: 160 },
        { prop: 'scanPrefix', label: '扫码内容前缀', width: 160 },
        { prop: 'scanCode', label: '扫码内容验证码', width: 160 },
        { prop: 'normName', label: '扫码品规', width: 160 },
        { prop: 'trueOrFalseStr', label: '验证真假', width: 80 },
        { prop: 'createTimeStr', label: '扫码时间', width: 160 },
        { prop: 'promoterStoreName', label: '推荐零售户', width: 160 },
        { prop: 'promoterScanTimeStr', label: '零售户推荐时间', width: 180 }
      ],
      caseListData: [],
      exchangeTableColumns: [
        { prop: 'settingName', label: '兑换名称', width: 160 },
        { prop: 'exchangeTimeStr', label: '兑换时间', width: 160 },
        { prop: 'integral', label: '兑换积分', width: 120 },
        { prop: 'isExpressStr', label: '是否邮寄', width: 120 },
        { prop: 'expressDateStr', label: '邮寄日期', width: 140 },
        { prop: 'expressName', label: '快递公司', width: 120 },
        { prop: 'expressNo', label: '快递单号', width: 160 },
        { prop: 'expressUserName', label: '寄件人', width: 120 },
        { prop: 'expressFee', label: '邮寄费用', width: 120 },
        { prop: 'expressStatusStr', label: '物流状态', width: 120 },
        { prop: 'isSignStr', label: '是否签收', width: 120 },
        { prop: 'lastExpressStatus', label: '最新物流信息', width: 160 },
        { prop: 'remark', label: '备注' }
      ],
      exchangeListData: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.activeTab = 'consumerInfo'
        this.dialogAddEditViewForm = {
          provinceName: '',
          provinceId: '',
          name: '',
          phone: '',
          sex: 1,
          status: 1,
          statusStr: '',
          integral: 0,
          integralTotal: 0,
          address: '',
          remark: ''
        }
        this.provinceOptions = []
        this.integralListData = []
        this.caseListData = []
        this.exchangeListData = []
        if (this.eventType !== 'add') {
          this.initConsumerData()
        }
        this.initProvinceSelectData()
      }
    }
  },
  methods: {
    changeTabFun() {

    },
    // 加载数据
    initConsumerData() {
      initAppConsumerApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        if (this.eventType === 'view') {
          this.initIntegralListData()
          this.initCaseListData()
          this.initExchangeListData()
        }
        this.loading = false
      })
    },
    // 获取用户积分信息
    initIntegralListData() {
      listAppConsumerIntegralListDataApi({ consumerId: this.dataId }).then(res => {
        this.integralListData = res.data ? res.data : []
      })
    },
    // 获取验真信息
    initCaseListData() {
      listSelectDataByConsumerIdApi({ consumerId: this.dataId }).then(res => {
        this.caseListData = res.data ? res.data : []
      })
    },
    // 获取兑换信息
    initExchangeListData() {
      listAppConsumerIntegralExchangeRewardListDataApi({ consumerId: this.dataId }).then(res => {
        this.exchangeListData = res.data ? res.data : []
      })
    },
    // 初始省区下拉数据
    initProvinceSelectData() {
      loadAreaDataApi({ parentId: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        if (this.eventType === 'add') {
          this.loading = false
        }
      })
    },
    // 选择省区回调
    changeProvinceFun(val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '消费者信息', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              if (this.dialogAddEditViewForm.type === 1) {
                this.dialogAddEditViewForm.storeName = this.relationListData[0].storeName
                this.dialogAddEditViewForm.certificateNo = this.relationListData[0].certificateNo
                this.dialogAddEditViewForm.benxiangStoreNo = this.relationListData[0].benxiangStoreNo
                this.dialogAddEditViewForm.storeData = JSON.stringify(this.relationListData)
              }
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave() {
      saveOrUpdateAppConsumerApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
</style>
